import { useState } from "react";
import { PhoneIncoming, QrCode, ChevronDown } from "lucide-react";

// Shows the details captured by Melissa (inbound call) or the QR / Sell Your Land
// form. These are NOT written onto the record's own fields — the user reviews them
// here and updates the record manually. Collapsed by default.
export function IntakeCard({ intake }) {
  const [open, setOpen] = useState(false);
  if (!intake || !Array.isArray(intake.fields) || intake.fields.length === 0) return null;
  const isQr = intake.source === "qr";
  const Icon = isQr ? QrCode : PhoneIncoming;
  return (
    <div className="rounded-lg border border-border bg-card overflow-hidden" data-testid="intake-card">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid="intake-card-toggle"
        aria-expanded={open}
        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-accent/40 transition-colors"
      >
        <div className="flex items-center gap-2 min-w-0">
          <Icon className="h-4 w-4 text-primary shrink-0" />
          <span className="text-sm font-semibold truncate">{isQr ? "Seller Intake (QR)" : "Melissa Call Intake"}</span>
          <span
            data-testid="intake-source-badge"
            className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${isQr ? "bg-sky-500/15 text-sky-400" : "bg-violet-500/15 text-violet-400"}`}
          >
            {isQr ? "QR" : "Melissa"}
          </span>
        </div>
        <ChevronDown className={`h-4 w-4 text-muted-foreground shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div data-testid="intake-card-body" className="border-t border-border">
          <div className="px-4 py-1 divide-y divide-border/60">
            {intake.fields.map((f, i) => (
              <div key={i} className="py-2" data-testid={`intake-field-${i}`}>
                <div className="text-[11px] uppercase tracking-wide text-muted-foreground">{f.label}</div>
                <div className="text-sm text-foreground mt-0.5 break-words">
                  {f.value ? f.value : <span className="text-muted-foreground/50">—</span>}
                </div>
              </div>
            ))}
          </div>

          {intake.call_summary ? (
            <div className="px-4 py-3 border-t border-border">
              <div className="text-[11px] uppercase tracking-wide text-muted-foreground mb-1">Call summary</div>
              <p className="text-sm text-foreground/90 break-words">{intake.call_summary}</p>
            </div>
          ) : null}

          {intake.recording_url ? (
            <div className="px-4 py-3 border-t border-border">
              <a href={intake.recording_url} target="_blank" rel="noreferrer" data-testid="intake-recording-link" className="text-xs text-primary hover:underline">
                Listen to call recording
              </a>
            </div>
          ) : null}

          <div className="px-4 py-2.5 border-t border-border bg-secondary/20">
            <p className="text-[11px] text-muted-foreground">Captured automatically — update the record manually from these details.</p>
          </div>
        </div>
      )}
    </div>
  );
}
